import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { RecommendationItemComponent } from '../recommendation-item/recommendation-item.component';
import { Recommendation } from '../../data-access/models/card-to-card-recommendation-response';
import { CommonModule } from '@angular/common';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { NgxButtonComponent } from '@digipay/ngx-button';

@Component({
  selector: 'c2c-applet-app-indirect-deleting-recommendation',
  standalone: true,
  imports: [CommonModule, RecommendationItemComponent, NgxButtonComponent],
  templateUrl: './indirect-deleting-recommendation.component.html',
  styleUrls: ['./indirect-deleting-recommendation.component.scss'],
})
export class IndirectDeletingRecommendationComponent {
  subscriptions: Subscription[] = [];

  recommendations: Recommendation[] = [];

  constructor(private bottomSheetService: NgxBottomSheetService) {
    this.recommendations = this.bottomSheetService.data()?.recommendations;
  }

  cancel() {
    this.bottomSheetService.closeBottomSheet();
  }

  save() {
    this.bottomSheetService.outputData.set({ confirmed: true });
    this.bottomSheetService.closeBottomSheet();
  }
}
